import { useContext, useEffect, lazy, Suspense } from "react";
import { Loader } from "semantic-ui-react";
import { AuthenticationContext, AuthenticationProvider, AUTH_MODES } from "./context";
// import { AuthPage } from "./auth-component/index";

const AuthPage = lazy(() => import("./auth-component"));

const AuthenticationComponent = ({ children }) => {
  const { authenticated, getCookie, getSession, error, sessionPending, requestAuthPending } =
    useContext(AuthenticationContext);

  useEffect(() => {
    // Check for existing session ids
    const sithsCookie = getCookie("sithssession");
    let sithsParam = new URLSearchParams(window.location.search).get("session");
    if (sithsParam === null) sithsParam = new URLSearchParams(window.location.search).get("sithssession");
    const bankidCookie = getCookie("bankidsession");
    const bankidParam = new URLSearchParams(window.location.search).get("bankidsession");

    if (sithsCookie || sithsParam !== null) {
      getSession(AUTH_MODES.siths, sithsCookie ? sithsCookie : sithsParam);
    } else if (bankidCookie || bankidParam !== null) {
      getSession(AUTH_MODES.bankid, bankidCookie ? bankidCookie : bankidParam);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (error) {
    return (
      <center>
        <p>{error ? error : "Det gick inte att logga in."}</p>
        <a href={window.location.href}>
          <p>Tryck här för att försöka igen.</p>
        </a>
      </center>
    );
  }

  if (authenticated) {
    return children;
  }

  if (sessionPending) {
    return (
      <div>
        <Loader active size="huge">
          Loggar in...
        </Loader>
      </div>
    );
  }

  if (requestAuthPending) {
    return (
      <div>
        <Loader active size="huge">
          Inväntar inlogg...
        </Loader>
      </div>
    );
  }

  return (
    <Suspense fallback={<div></div>}>
      <AuthPage onSuccess={(data) => getSession(data.authMode, data.sessionId)} />
    </Suspense>
  );
};

export const AuthenticationWrapper = ({ children }) => (
  <AuthenticationProvider>
    <AuthenticationComponent>{children}</AuthenticationComponent>
  </AuthenticationProvider>
);

// Returns given component if user has matching permissions
export const PermissionComponentWrapper = ({ children, permissions, warn }) => {
  const { isPermitted } = useContext(AuthenticationContext);
  if (!permissions || isPermitted(permissions)) return children;
  return warn ? <p>Du saknar behörighet för att se detta innehåll.</p> : <></>;
};
